import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/header/header';
import Footer from './components/footer/footer';
import FloatingContact from './components/floatingContact/FloatingContact';
import Home from './pages/home/home.jsx';
import About from './pages/about/about.jsx';
import Admin from './pages/admin/Admin.jsx';
import Login from './pages/admin/Login.jsx';

function AppContent() {
  const location = useLocation();
  const isAdminPath = location.pathname.startsWith('/admin');

  return (
    <div className="App">
      {!isAdminPath && <Header />}
      <div className={isAdminPath ? "admin-layout-content" : "main-content"}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/login" element={<Login />} />
        </Routes>
      </div>
      {!isAdminPath && <Footer />}
      {!isAdminPath && <FloatingContact />}
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <AppContent />
      </Router>
    </LanguageProvider>
  );
}

export default App;